import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Filters from '../../../filters/components/Filters';

const CustomReportFilters = (props) => {
  const {
    onExportToCsv,
    onExportToPdf,
    isFetching,
    ...otherProps
  } = props;
  return (
    <div className="o-flexbox o-flexbox--justify-start">
      <Filters {...otherProps} isFetching />
      <button
        type="button"
        className={classnames('c-btn c-btn--medium u-border-radius-8 u-ml', {
          'is-disabled': isFetching,
        })}
        onClick={onExportToCsv}
        disabled={isFetching}
      >Export to CSV</button>
      <button
        type="button"
        className={classnames('c-btn c-btn--medium u-border-radius-8 u-ml', {
          'is-disabled': isFetching,
        })}
        onClick={onExportToPdf}
        disabled={isFetching}
      >Export to PDF</button>
    </div>
  );
};

CustomReportFilters.propTypes = {
  onExportToCsv: PropTypes.func.isRequired,
  onExportToPdf: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

export default CustomReportFilters;
